import React, { useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

// Animação de borda neon
const neonGlow = keyframes`
  0%, 100% { box-shadow: 0 0 0px #64B6FF55, 0 0 16px #00ffc822; }
  50% { box-shadow: 0 0 16px #64B6FF, 0 0 32px #00ffc8; }
`;

const InputGroup = styled.div`
  position: relative;
  margin-bottom: 1.5rem;
`;

const FloatingLabel = styled.label`
  position: absolute;
  left: 18px;
  top: ${({ active }) => (active ? '3px' : '18px')};
  font-size: ${({ active }) => (active ? '0.95rem' : '1.08rem')};
  color: ${({ active }) => (active ? '#64B6FF' : '#90CAFF')};
  background: rgba(10,25,47,0.88);
  padding: 0 6px;
  pointer-events: none;
  transition: all 0.22s cubic-bezier(.4,2,.6,1);
  z-index: 2;
`;

const NeonInput = styled.input`
  width: 100%;
  padding: 1.2rem 1.2rem 1.2rem 1.2rem;
  border-radius: 10px;
  border: 2px solid #64B6FF55;
  background: rgba(16, 32, 64, 0.44);
  color: #fff;
  font-size: 1.08rem;
  outline: none;
  margin-bottom: 0.1rem;
  transition: border 0.2s, box-shadow 0.2s;
  box-shadow: 0 0 0px #64B6FF22;
  ${({ active }) =>
    active &&
    css`
      border: 2px solid #64B6FF;
      animation: ${neonGlow} 1.4s infinite;
      box-shadow: 0 0 24px #64B6FF88;
    `}
  &::placeholder {
    color: #7bbcff44;
    opacity: 1;
    font-size: 1.03rem;
  }
`;

export default function HoloInput({ label, value, onChange, name, type = 'text', required, autoFocus }) {
  const [focused, setFocused] = useState(false);
  // --- CORREÇÃO: PULSE APENAS NO INPUT FOCADO ---
  const active = focused;
  return (
    <InputGroup>
      <FloatingLabel htmlFor={name} active={focused || !!value}>{label}</FloatingLabel>
      <NeonInput
        id={name}
        name={name}
        value={value}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        onChange={onChange}
        active={active}
        type={type}
        required={required}
        autoFocus={autoFocus}
        autoComplete="off"
      />
    </InputGroup>
  );
}
